webpackJsonp([26],{

/***/ 1517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HerdsWeightView_vue__ = __webpack_require__(1854);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca1cffea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HerdsWeightView_vue__ = __webpack_require__(2127);
function injectStyle (ssrContext) {
  __webpack_require__(2118)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca1cffea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HerdsWeightView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca1cffea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HerdsWeightView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createChartTheme */
/* unused harmony export chartTooltipColors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chartThemeMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme__);



// Wykresy rysują na canvasie, więc tokeny CSS z theme.css do nich nie sięgają —
// motyw SciChart dobieramy osobno, z tego samego rozwiązanego motywu aplikacji.

// Tło jak --surface ciemnego motywu, zamiast grafitowego gradientu paczki,
// żeby wykres nie odcinał się od karty, w której stoi.
var DARK_BACKGROUND = "#172124";

function createChartTheme(resolvedTheme) {
    if (resolvedTheme !== "dark") return new __WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme__["SciChartJSLightTheme"]();

    var theme = new __WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme__["SciChartJSDarkv2Theme"]();
    theme.sciChartBackground = DARK_BACKGROUND;
    theme.loadingAnimationBackground = DARK_BACKGROUND;
    return theme;
}

// Dymki rollovera rysowane własnym szablonem SVG mają kolory wpisane w SVG,
// więc applyTheme ich nie zmienia. Jasne to dotychczasowy biały dymek z czarnym
// tekstem, ciemne — kolory wysuwanych paneli z theme.css (--popover-*).
var TOOLTIP_COLORS = {
    light: { background: "#ffffff", border: "#000000", text: "#000000" },
    dark: { background: "#1b2629", border: "#50676d", text: "#e8f1f3" }
};

function chartTooltipColors(resolvedTheme) {
    return resolvedTheme === "dark" ? TOOLTIP_COLORS.dark : TOOLTIP_COLORS.light;
}

// Wykres woła this.chartTheme() przy tworzeniu powierzchni, a mixin
// przemalowuje już narysowane wykresy, gdy użytkownik zmieni motyw.
// Wymaga, żeby komponent trzymał powierzchnię w this.sciChartSurface.
var chartThemeMixin = {
    watch: {
        "$store.getters.resolvedTheme": function $storeGettersResolvedTheme() {
            if (this.sciChartSurface) this.sciChartSurface.applyTheme(this.chartTheme());
        }
    },
    methods: {
        chartTheme: function chartTheme() {
            return createChartTheme(this.$store.getters.resolvedTheme);
        },

        // Szablon dymka woła to przy każdym rysowaniu, więc zmiana motywu działa od razu.
        tooltipColors: function tooltipColors() {
            return chartTooltipColors(this.$store.getters.resolvedTheme);
        }
    }
};

/***/ }),

/***/ 1731:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_SciChartSurface__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_SciChartSurface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_SciChartSurface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_NumericAxis__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_NumericAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_NumericAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_types_AxisAlignment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_types_AxisAlignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_scichart_types_AxisAlignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Model_XyDataSeries__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Model_XyDataSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Model_XyDataSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RolloverModifier__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RolloverModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RolloverModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_chartTheme__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Drawing_WebGlRenderContext2D__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Drawing_WebGlRenderContext2D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Drawing_WebGlRenderContext2D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Model_Filters_XyLinearTrendFilter__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Model_Filters_XyLinearTrendFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Model_Filters_XyLinearTrendFilter__);


//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_11__utils_chartTheme__["a" /* chartThemeMixin */]],
    props: {
        systemId: {
            required: true
        },
        sid: {
            default: 0,
            required: false
        },
        // Wysokosc plotna - pozwala rodzicowi zarezerwowac miejsce na wykres,
        // zeby uklad nie skakal, gdy SciChart skonczy inicjalizacje.
        height: {
            type: Number,
            default: null,
            required: false
        }
    },
    data: function data() {
        return {
            sciChartSurface: null,
            wasmContext: null,
            xAxis: null,
            yAxis: null,
            pointsCount: 0
        };
    },

    computed: {
        surfaceStyle: function surfaceStyle() {
            var style = { width: '100%', marginRight: '10px' };

            if (this.height != null) {
                style.height = this.height + 'px';
            }

            return style;
        }
    },
    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var result;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_26" /* getHerdWeight */])(_this.systemId);

                            case 3:
                                result = _context.sent;
                                _context.next = 6;
                                return _this.initSciChart(result);

                            case 6:
                                _this.$emit('loaded', { isEmpty: _this.pointsCount == 0 });
                                _context.next = 13;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](0);

                                console.error(_context.t0);
                                _this.$emit('failed', _context.t0);

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[0, 9]]);
            }))();
        },
        initSciChart: function initSciChart(data) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var xValues, yValues, _ref, sciChartSurface, wasmContext, points, bridges, known, lineSeries, gapSeries, linearTrendFilter, filteredLine, rolloverModifier;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                xValues = data.labels;
                                yValues = data.values;
                                _context2.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_SciChartSurface__["SciChartSurface"].create('scichart-root-herd-weight-' + _this2.sid);

                            case 4:
                                _ref = _context2.sent;
                                sciChartSurface = _ref.sciChartSurface;
                                wasmContext = _ref.wasmContext;


                                _this2.sciChartSurface = sciChartSurface;
                                _this2.wasmContext = wasmContext;

                                _context2.next = 11;
                                return sciChartSurface.applyTheme(_this2.chartTheme());

                            case 11:

                                _this2.xAxis = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this2.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_6_scichart_types_AxisAlignment__["EAxisAlignment"].Top });
                                _this2.yAxis = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this2.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_6_scichart_types_AxisAlignment__["EAxisAlignment"].Left });

                                _this2.yAxis.growBy = new __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__["NumberRange"](0.1, 0.1);
                                _this2.xAxis.growBy = new __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__["NumberRange"](0.01, 0.01);

                                sciChartSurface.xAxes.add(_this2.xAxis);
                                sciChartSurface.yAxes.add(_this2.yAxis);

                                _this2.xAxis.labelProvider.formatLabel = function (unixTimestamp) {
                                    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(unixTimestamp).format("YYYY-MM-DD");
                                };

                                points = _this2.buildPoints(xValues, yValues);
                                bridges = _this2.buildGapBridges(points);
                                known = _this2.getKnownPoints(points);


                                _this2.pointsCount = points.x.length;

                                lineSeries = new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this2.wasmContext, {
                                    stroke: "#0095B2",
                                    drawNaNAs: __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                                    strokeThickness: 2,
                                    pointMarker: new __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__["EllipsePointMarker"](wasmContext, {
                                        width: 6,
                                        height: 6,
                                        strokeThickness: 2,
                                        fill: "#0095B230",
                                        stroke: "#0095B2"
                                    })
                                });


                                lineSeries.dataSeries = new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this2.wasmContext, {
                                    xValues: points.x,
                                    yValues: points.y
                                });

                                if (points.x.length > 0) {
                                    lineSeries.strokeThickness = 3;
                                    lineSeries.rolloverModifierProps.tooltipLabelX = _this2.labelX ? _this2.labelX : "X";
                                    lineSeries.rolloverModifierProps.tooltipLabelY = _this2.labelY ? _this2.labelY : "Y";
                                    lineSeries.rolloverModifierProps.tooltipTemplate = _this2.tooltipTemplateMethod;
                                }

                                _this2.sciChartSurface.renderableSeries.add(lineSeries);

                                // GAP LINE - dni bez danych spinamy linia przerywana, zeby bylo widac,
                                // ze pomiaru nie bylo, a nie ze waga stada spadla do zera.
                                gapSeries = null;


                                if (bridges.x.length > 0) {
                                    gapSeries = new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this2.wasmContext, {
                                        stroke: "#0095B2",
                                        strokeThickness: 2,
                                        strokeDashArray: [4, 4],
                                        drawNaNAs: __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                                        dataSeries: new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this2.wasmContext, {
                                            xValues: bridges.x,
                                            yValues: bridges.y
                                        })
                                    });

                                    _this2.sciChartSurface.renderableSeries.add(gapSeries);
                                }
                                // END OF GAP LINE

                                // TREND LINE - z jednego pomiaru regresja liczy 0/0 i daje NaN, ktore psuje os Y.
                                if (known.x.length >= 2) {
                                    linearTrendFilter = new __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Model_Filters_XyLinearTrendFilter__["XyLinearTrendFilter"](new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this2.wasmContext, {
                                        xValues: known.x,
                                        yValues: known.y
                                    }), { dataSeriesName: _this2.$t('trendLine') });
                                    filteredLine = new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this2.wasmContext, {
                                        dataSeries: linearTrendFilter,
                                        stroke: "#ff0000",
                                        strokeThickness: 2,
                                        rolloverModifier: null
                                    });

                                    filteredLine.rolloverModifierProps.tooltipTemplate = _this2.trendTemplateMethod;

                                    _this2.sciChartSurface.renderableSeries.add(filteredLine);
                                }
                                // END OF TREND LINE

                                rolloverModifier = new __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RolloverModifier__["RolloverModifier"]();

                                rolloverModifier.showRolloverLine = false;
                                _this2.sciChartSurface.chartModifiers.add(rolloverModifier);

                                if (gapSeries != null) {
                                    // Punkty spinajace pokrywaja sie z prawdziwymi pomiarami - bez tego
                                    // ten sam dzien pokazywalby sie w dymku dwa razy.
                                    rolloverModifier.includeSeries(gapSeries, false);
                                }

                                // this.sciChartSurface.chartModifiers.add(new CursorModifier({
                                //     crosshairStroke: "#0095B2",
                                //     crosshairStrokeThickness: 1,
                                //     tooltipContainerBackground: "#000",
                                //     tooltipTextStroke: "#0095B2",
                                //     showTooltip: false,
                                //     axisLabelFill: "#0095B2",
                                //     axisLabelStroke: "#fff",
                                // }))

                            case 33:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        buildPoints: function buildPoints(labels, values) {
            // null z API oznacza dzien bez danych - jako NaN robi w serii przerwe.
            var x = [];
            var y = [];

            if (labels == undefined || labels == null) {
                return { x: x, y: y };
            }

            for (var i = 0; i < labels.length; i++) {
                var value = values == undefined || values == null ? null : values[i];

                x.push(new Date(__WEBPACK_IMPORTED_MODULE_3_moment___default()(labels[i])).getTime());
                y.push(value == undefined || value == null ? NaN : Math.round(value / 1000));
            }

            return { x: x, y: y };
        },
        buildGapBridges: function buildGapBridges(points) {
            // Kazda przerwe spinamy odcinkiem od ostatniego znanego punktu do pierwszego kolejnego.
            // Separator miedzy odcinkami to NaN tylko w Y - X musi zostac prawdziwa liczba,
            // bo SciChart bierze zakres osi X z pierwszego i ostatniego X; NaN w X psuje
            // cala os ("Argument min must be a real number").
            var x = [];
            var y = [];
            var lastKnown = -1;

            for (var i = 0; i < points.y.length; i++) {
                if (isNaN(points.y[i])) {
                    continue;
                }

                if (lastKnown >= 0 && i - lastKnown > 1) {
                    x.push(points.x[lastKnown], points.x[i], points.x[i]);
                    y.push(points.y[lastKnown], points.y[i], NaN);
                }

                lastKnown = i;
            }

            return { x: x, y: y };
        },
        getKnownPoints: function getKnownPoints(points) {
            // Linia trendu liczona tylko z dni, ktore faktycznie maja pomiar.
            var x = [];
            var y = [];

            for (var i = 0; i < points.y.length; i++) {
                if (isNaN(points.y[i])) {
                    continue;
                }

                x.push(points.x[i]);
                y.push(points.y[i]);
            }

            return { x: x, y: y };
        },
        tooltipTemplateMethod: function tooltipTemplateMethod(id, seriesInfo, rolloverTooltip) {
            var colors = this.tooltipColors();
            // Rozmiar zgłaszany SciChartowi = prostokąt z obrysem. Dawne 200x120
            // odsuwało dymek od punktu w lewo i w górę, poza wąski wykres.
            var width = 152;
            var height = 42;
            rolloverTooltip.updateSize(width, height);

            return '<svg width="' + width + '" height="' + height + '">\n                <rect x="1" y="1" height="40" width="150" rx="5" style="stroke-width:1; stroke:' + colors.border + '" fill="' + colors.background + '"/>\n                <svg>\n                    <text font-size="13" font-family="Verdana" fill="' + colors.text + '">\n                        <tspan x="11" dy="1.2em">' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(Math.floor(seriesInfo.formattedXValue)).format("DD-MM-YYYY") + '</tspan>\n                        <tspan x="11" dy="1.2em">' + parseFloat(seriesInfo.formattedYValue).toFixed(2) + ' kg</tspan>\n                    </text>\n                    <defs>\n                        <filter id="f1" x="0" y="0" width="200%" height="200%">\n                        <feOffset result="offOut" in="SourceGraphic" dx="20" dy="20" />\n                        <feBlend in="SourceGraphic" in2="offOut" mode="normal" />\n                        </filter>\n                    </defs>\n                </svg>\n                </svg>';
        },
        trendTemplateMethod: function trendTemplateMethod(id, seriesInfo, rolloverTooltip) {
            var tooltipColor = rolloverTooltip.tooltipProps.tooltipColor;

            var colors = this.tooltipColors();
            var width = 152;
            var height = 32;
            rolloverTooltip.updateSize(width, height);

            return '<svg width="' + width + '" height="' + height + '">\n                <rect x="1" y="1" height="30" width="150" rx="5" style="stroke-width:2; stroke:' + tooltipColor + '" fill="' + colors.background + '"/>\n                <svg>\n                    <text font-size="13" font-family="Verdana" fill="' + colors.text + '">\n                        <tspan x="11" dy="1.2em">' + seriesInfo.formattedYValue + ' kg</tspan>\n                    </text>\n                    <defs>\n                    <filter id="f1" x="0" y="0" width="200%" height="200%">\n                        <feOffset result="offOut" in="SourceGraphic" dx="20" dy="20" />\n                        <feBlend in="SourceGraphic" in2="offOut" mode="normal" />\n                    </filter>\n                    </defs>\n                </svg>\n            </svg>';
        }
    },
    mounted: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.getData();

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref2.apply(this, arguments);
        }

        return mounted;
    }(),
    beforeDestroy: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (this.sciChartSurface || this.wasmContext) {
                                this.sciChartSurface = null;
                                this.wasmContext = null;
                            }
                            this.sciChartSurface = null;
                            this.wasmContext = null;

                        case 3:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function beforeDestroy() {
            return _ref3.apply(this, arguments);
        }

        return beforeDestroy;
    }()
});

/***/ }),

/***/ 1784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartHerdWeight_vue__ = __webpack_require__(1731);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_564f742b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartHerdWeight_vue__ = __webpack_require__(1787);
function injectStyle (ssrContext) {
  __webpack_require__(1785)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-564f742b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartHerdWeight_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_564f742b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartHerdWeight_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1785:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1786);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("4cdfd431", content, true, {});

/***/ }),

/***/ 1786:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SciChartHerdWeight.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1787:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"horizontal"},[_c('div',{style:(_vm.surfaceStyle),attrs:{"id":'scichart-root-herd-weight-'+_vm.sid}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1854:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Systems_SystemHerdWeightCard_vue__ = __webpack_require__(2120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Charts_ChartSkeleton_vue__ = __webpack_require__(1856);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HerdsWeightView',
    components: {
        SystemHerdWeightCard: __WEBPACK_IMPORTED_MODULE_3__components_Systems_SystemHerdWeightCard_vue__["a" /* default */],
        ChartSkeleton: __WEBPACK_IMPORTED_MODULE_4__components_Charts_ChartSkeleton_vue__["a" /* default */]
    },
    data: function data() {
        return {
            systems: [],
            loading: true,
            error: false,
            chartHeight: 260,
            skeletonsCount: 6
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var result;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.loading = true;
                                _this.error = false;

                                _context.prev = 2;
                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api__["_85" /* getSystemsStatusList */])();

                            case 5:
                                result = _context.sent;

                                _this.systems = result.filter(function (x) {
                                    return x.hasWeight;
                                }).sort(_this.sortSystemsByName);
                                _context.next = 14;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](2);

                                console.error(_context.t0);
                                _this.systems = [];
                                _this.error = true;

                            case 14:
                                _context.prev = 14;

                                _this.loading = false;
                                return _context.finish(14);

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[2, 9, 14, 17]]);
            }))();
        },
        sortSystemsByName: function sortSystemsByName(a, b) {
            return a.name.localeCompare(b.name, undefined, {
                numeric: true,
                sensitivity: 'base'
            });
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            this.getData();

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Charts_SciChartHerdWeight_vue__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Charts_ChartSkeleton_vue__ = __webpack_require__(1856);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SystemHerdWeightCard',
    components: {
        SciChartHerdWeight: __WEBPACK_IMPORTED_MODULE_0__Charts_SciChartHerdWeight_vue__["a" /* default */],
        ChartSkeleton: __WEBPACK_IMPORTED_MODULE_1__Charts_ChartSkeleton_vue__["a" /* default */]
    },
    props: {
        system: {
            type: Object,
            required: true
        },
        chartHeight: {
            type: Number,
            default: 260
        }
    },
    data: function data() {
        return {
            // loading -> ready | empty | failed
            state: 'loading',
            // Zmiana klucza wymusza przemontowanie wykresu przy ponownej probie.
            chartKey: 0
        };
    },

    computed: {
        isLoading: function isLoading() {
            return this.state == 'loading';
        },
        isReady: function isReady() {
            return this.state == 'ready';
        },
        isFailed: function isFailed() {
            return this.state == 'failed';
        },
        message: function message() {
            return this.isFailed ? this.$t('HerdWeightLoadFailed') : this.$t('HerdWeightNoData');
        }
    },
    methods: {
        onLoaded: function onLoaded(result) {
            this.state = result != null && result.isEmpty ? 'empty' : 'ready';
        },
        onFailed: function onFailed() {
            this.state = 'failed';
        },
        reload: function reload() {
            this.state = 'loading';
            this.chartKey++;
        }
    }
});

/***/ }),

/***/ 1856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartSkeleton_vue__ = __webpack_require__(1857);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b61a0558_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartSkeleton_vue__ = __webpack_require__(2125);
function injectStyle (ssrContext) {
  __webpack_require__(2123)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b61a0558"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartSkeleton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b61a0558_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartSkeleton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ChartSkeleton',
    props: {
        height: {
            type: Number,
            default: 260
        }
    },
    data: function data() {
        return {
            // Staly uklad slupkow - losowanie powodowaloby migotanie przy kazdym przerysowaniu.
            bars: [30, 48, 40, 62, 55, 74, 60, 82, 70, 90, 66, 78]
        };
    }
});

/***/ }),

/***/ 2118:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2119);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("ad16c38c", content, true, {});

/***/ }),

/***/ 2119:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".herds-view[data-v-ca1cffea]{padding:10px 20px;max-height:calc(100vh - 70px);overflow-y:auto}.herds-grid[data-v-ca1cffea]{display:grid;grid-template-columns:repeat(auto-fill,minmax(min(100%,max(300px,calc((100% - 30px) / 3))),1fr));gap:15px}.herd-card-skeleton[data-v-ca1cffea]{padding:10px 12px;background:#414f51;border:1px solid #30383a;border-radius:5px}.skeleton-line[data-v-ca1cffea]{width:40%;height:16px;margin-bottom:10px;border-radius:4px;background:-webkit-gradient(linear,left top,right top,color-stop(25%,#4d5b5d),color-stop(37%,#5c6b6d),color-stop(63%,#4d5b5d));background:linear-gradient(90deg,#4d5b5d 25%,#5c6b6d 37%,#4d5b5d 63%);background-size:400% 100%;-webkit-animation:skeleton-loading-data-v-ca1cffea 1.4s ease infinite;animation:skeleton-loading-data-v-ca1cffea 1.4s ease infinite}@-webkit-keyframes skeleton-loading-data-v-ca1cffea{0%{background-position:100% 50%}to{background-position:0 50%}}@keyframes skeleton-loading-data-v-ca1cffea{0%{background-position:100% 50%}to{background-position:0 50%}}.herds-view__state[data-v-ca1cffea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;color:gray;font-size:16px;text-align:center;padding:40px 10px}.herds-view__retry[data-v-ca1cffea]{color:#fff;background:#414f51;border:1px solid #30383a;border-radius:5px;padding:5px 15px;font-size:14px;cursor:pointer}.herds-view__retry[data-v-ca1cffea]:hover{background:#30383a}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/HerdsWeightView.vue"],"names":[],"mappings":"AACA,6BACI,kBAAmB,AACnB,8BAA+B,AAC/B,eAAiB,CACpB,AAKD,6BACI,aAAc,AACd,iGAAsG,AACtG,QAAU,CACb,AACD,qCACI,kBAAmB,AACnB,mBAAoB,AACpB,yBAA0B,AAC1B,iBAAmB,CACtB,AACD,gCACI,UAAW,AACX,YAAa,AACb,mBAAoB,AACpB,kBAAmB,AACnB,+HAAwI,AACxI,sEAA0E,AAC1E,0BAA2B,AAC3B,sEAAuE,AAC/D,6DAA+D,CAC1E,AACD,oDACA,GAAK,4BAA8B,CAClC,AACD,GAAO,yBAA2B,CACjC,CACA,AACD,4CACA,GAAK,4BAA8B,CAClC,AACD,GAAO,yBAA2B,CACjC,CACA,AACD,oCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,WAAY,AACZ,eAAgB,AAChB,kBAAmB,AACnB,iBAAmB,CACtB,AACD,oCACI,WAAa,AACb,mBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,iBAAkB,AAClB,eAAgB,AAChB,cAAgB,CACnB,AACD,0CACI,kBAAoB,CACvB","file":"HerdsWeightView.vue","sourcesContent":["\n.herds-view[data-v-ca1cffea] {\n    padding: 10px 20px;\n    max-height: calc(100vh - 70px);\n    overflow-y: auto;\n}\n\n/* Najwyżej trzy wykresy w rzędzie, rozciągnięte na całą szerokość: kolumna ma co\n   najmniej 1/3 siatki (minus dwa odstępy po 15px), więc czwarta się nie mieści.\n   Gdy 1/3 to mniej niż 300px, zostają dwie kolumny, a na wąskim ekranie jedna. */\n.herds-grid[data-v-ca1cffea] {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(min(100%, max(300px, calc((100% - 30px) / 3))), 1fr));\n    gap: 15px;\n}\n.herd-card-skeleton[data-v-ca1cffea] {\n    padding: 10px 12px;\n    background: #414F51;\n    border: 1px solid #30383a;\n    border-radius: 5px;\n}\n.skeleton-line[data-v-ca1cffea] {\n    width: 40%;\n    height: 16px;\n    margin-bottom: 10px;\n    border-radius: 4px;\n    background: -webkit-gradient(linear, left top, right top, color-stop(25%, #4d5b5d), color-stop(37%, #5c6b6d), color-stop(63%, #4d5b5d));\n    background: linear-gradient(90deg, #4d5b5d 25%, #5c6b6d 37%, #4d5b5d 63%);\n    background-size: 400% 100%;\n    -webkit-animation: skeleton-loading-data-v-ca1cffea 1.4s ease infinite;\n            animation: skeleton-loading-data-v-ca1cffea 1.4s ease infinite;\n}\n@-webkit-keyframes skeleton-loading-data-v-ca1cffea {\n0% { background-position: 100% 50%;\n}\n100% { background-position: 0 50%;\n}\n}\n@keyframes skeleton-loading-data-v-ca1cffea {\n0% { background-position: 100% 50%;\n}\n100% { background-position: 0 50%;\n}\n}\n.herds-view__state[data-v-ca1cffea] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 10px;\n    color: gray;\n    font-size: 16px;\n    text-align: center;\n    padding: 40px 10px;\n}\n.herds-view__retry[data-v-ca1cffea] {\n    color: white;\n    background: #414F51;\n    border: 1px solid #30383a;\n    border-radius: 5px;\n    padding: 5px 15px;\n    font-size: 14px;\n    cursor: pointer;\n}\n.herds-view__retry[data-v-ca1cffea]:hover {\n    background: #30383a;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemHerdWeightCard_vue__ = __webpack_require__(1855);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f1505a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemHerdWeightCard_vue__ = __webpack_require__(2126);
function injectStyle (ssrContext) {
  __webpack_require__(2121)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67f1505a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemHerdWeightCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f1505a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemHerdWeightCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2121:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2122);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("0489ed86", content, true, {});

/***/ }),

/***/ 2122:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".herd-card[data-v-67f1505a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;color:#fff;padding:10px 12px;background:#414f51;border:1px solid #30383a;border-radius:5px;-webkit-transition-duration:.5s;transition-duration:.5s}.herd-card__header[data-v-67f1505a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:10px;margin-bottom:5px}.herd-card__title[data-v-67f1505a]{margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.herd-card__badge[data-v-67f1505a]{-ms-flex-negative:0;flex-shrink:0;font-size:12px;color:#b7c2c3}.herd-card__body[data-v-67f1505a],.herd-card__chart[data-v-67f1505a]{position:relative}.herd-card__overlay[data-v-67f1505a]{position:absolute;top:0;left:0;right:0;bottom:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#414f51}.herd-card__message[data-v-67f1505a],.herd-card__overlay[data-v-67f1505a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.herd-card__message[data-v-67f1505a]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:10px;color:gray;font-size:14px;text-align:center;padding:0 10px}.herd-card__retry[data-v-67f1505a]{color:#fff;background:#30383a;border:1px solid #253032;border-radius:5px;padding:4px 12px;font-size:13px;cursor:pointer}.herd-card__retry[data-v-67f1505a]:hover{background:#253032}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/SystemHerdWeightCard.vue"],"names":[],"mappings":"AACA,4BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,WAAa,AACb,kBAAmB,AACnB,mBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,gCAAkC,AAC1B,uBAA0B,CACrC,AACD,oCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,SAAU,AACV,iBAAmB,CACtB,AACD,mCACI,SAAU,AACV,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACvB,AACD,mCACI,oBAAqB,AACjB,cAAe,AACnB,eAAgB,AAChB,aAAe,CAClB,AAID,qEACI,iBAAmB,CACtB,AAGD,qCACI,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AAOV,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,kBAAoB,CACvB,AACD,0EAXI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAsB/B,AAhBD,qCAII,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAI/B,SAAU,AACV,WAAY,AACZ,eAAgB,AAChB,kBAAmB,AACnB,cAAgB,CACnB,AACD,mCACI,WAAa,AACb,mBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,iBAAkB,AAClB,eAAgB,AAChB,cAAgB,CACnB,AACD,yCACI,kBAAoB,CACvB","file":"SystemHerdWeightCard.vue","sourcesContent":["\n.herd-card[data-v-67f1505a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    color: white;\n    padding: 10px 12px;\n    background: #414F51;\n    border: 1px solid #30383a;\n    border-radius: 5px;\n    -webkit-transition-duration: 0.5s;\n            transition-duration: 0.5s;\n}\n.herd-card__header[data-v-67f1505a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    gap: 10px;\n    margin-bottom: 5px;\n}\n.herd-card__title[data-v-67f1505a] {\n    margin: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.herd-card__badge[data-v-67f1505a] {\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    font-size: 12px;\n    color: #b7c2c3;\n}\n.herd-card__body[data-v-67f1505a] {\n    position: relative;\n}\n.herd-card__chart[data-v-67f1505a] {\n    position: relative;\n}\n\n/* Zaslepka i komunikaty przykrywaja plotno, zeby SciChart caly czas mial kontener. */\n.herd-card__overlay[data-v-67f1505a] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    background: #414F51;\n}\n.herd-card__message[data-v-67f1505a] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 10px;\n    color: gray;\n    font-size: 14px;\n    text-align: center;\n    padding: 0 10px;\n}\n.herd-card__retry[data-v-67f1505a] {\n    color: white;\n    background: #30383a;\n    border: 1px solid #253032;\n    border-radius: 5px;\n    padding: 4px 12px;\n    font-size: 13px;\n    cursor: pointer;\n}\n.herd-card__retry[data-v-67f1505a]:hover {\n    background: #253032;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2123:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2124);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("626960c7", content, true, {});

/***/ }),

/***/ 2124:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".chart-skeleton[data-v-b61a0558]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;padding:10px 5px 0}.chart-skeleton__plot[data-v-b61a0558]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;gap:6px;min-height:0}.chart-skeleton__bar[data-v-b61a0558]{-webkit-box-flex:1;-ms-flex:1;flex:1;border-radius:4px 4px 0 0}.chart-skeleton__axis[data-v-b61a0558],.chart-skeleton__bar[data-v-b61a0558]{background:-webkit-gradient(linear,left top,right top,color-stop(25%,#4d5b5d),color-stop(37%,#5c6b6d),color-stop(63%,#4d5b5d));background:linear-gradient(90deg,#4d5b5d 25%,#5c6b6d 37%,#4d5b5d 63%);background-size:400% 100%;-webkit-animation:chart-skeleton-loading-data-v-b61a0558 1.4s ease infinite;animation:chart-skeleton-loading-data-v-b61a0558 1.4s ease infinite}.chart-skeleton__axis[data-v-b61a0558]{height:8px;margin-top:8px;border-radius:4px}@-webkit-keyframes chart-skeleton-loading-data-v-b61a0558{0%{background-position:100% 50%}to{background-position:0 50%}}@keyframes chart-skeleton-loading-data-v-b61a0558{0%{background-position:100% 50%}to{background-position:0 50%}}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Charts/ChartSkeleton.vue"],"names":[],"mappings":"AACA,iCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,WAAY,AACZ,kBAAwB,CAC3B,AACD,uCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,QAAS,AACT,YAAc,CACjB,AACD,sCACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,yBAA2B,CAM9B,AACD,6EANI,+HAAwI,AACxI,sEAA0E,AAC1E,0BAA2B,AAC3B,4EAA6E,AACrE,mEAAqE,CAWhF,AATD,uCACI,WAAY,AACZ,eAAgB,AAChB,iBAAmB,CAMtB,AACD,0DACA,GAAK,4BAA8B,CAClC,AACD,GAAO,yBAA2B,CACjC,CACA,AACD,kDACA,GAAK,4BAA8B,CAClC,AACD,GAAO,yBAA2B,CACjC,CACA","file":"ChartSkeleton.vue","sourcesContent":["\n.chart-skeleton[data-v-b61a0558] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    width: 100%;\n    padding: 10px 5px 0 5px;\n}\n.chart-skeleton__plot[data-v-b61a0558] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n    gap: 6px;\n    min-height: 0;\n}\n.chart-skeleton__bar[data-v-b61a0558] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    border-radius: 4px 4px 0 0;\n    background: -webkit-gradient(linear, left top, right top, color-stop(25%, #4d5b5d), color-stop(37%, #5c6b6d), color-stop(63%, #4d5b5d));\n    background: linear-gradient(90deg, #4d5b5d 25%, #5c6b6d 37%, #4d5b5d 63%);\n    background-size: 400% 100%;\n    -webkit-animation: chart-skeleton-loading-data-v-b61a0558 1.4s ease infinite;\n            animation: chart-skeleton-loading-data-v-b61a0558 1.4s ease infinite;\n}\n.chart-skeleton__axis[data-v-b61a0558] {\n    height: 8px;\n    margin-top: 8px;\n    border-radius: 4px;\n    background: -webkit-gradient(linear, left top, right top, color-stop(25%, #4d5b5d), color-stop(37%, #5c6b6d), color-stop(63%, #4d5b5d));\n    background: linear-gradient(90deg, #4d5b5d 25%, #5c6b6d 37%, #4d5b5d 63%);\n    background-size: 400% 100%;\n    -webkit-animation: chart-skeleton-loading-data-v-b61a0558 1.4s ease infinite;\n            animation: chart-skeleton-loading-data-v-b61a0558 1.4s ease infinite;\n}\n@-webkit-keyframes chart-skeleton-loading-data-v-b61a0558 {\n0% { background-position: 100% 50%;\n}\n100% { background-position: 0 50%;\n}\n}\n@keyframes chart-skeleton-loading-data-v-b61a0558 {\n0% { background-position: 100% 50%;\n}\n100% { background-position: 0 50%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-skeleton",style:({ height: _vm.height + 'px' })},[_c('div',{staticClass:"chart-skeleton__plot"},_vm._l((_vm.bars),function(bar,index){return _c('div',{key:index,staticClass:"chart-skeleton__bar",style:({ height: bar + '%' })})}),0),_vm._v(" "),_c('div',{staticClass:"chart-skeleton__axis"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"herd-card"},[_c('header',{staticClass:"herd-card__header"},[_c('h5',{staticClass:"herd-card__title",attrs:{"title":_vm.system.name}},[_vm._v(_vm._s(_vm.system.name))]),_vm._v(" "),(_vm.isLoading)?_c('span',{staticClass:"herd-card__badge"},[_vm._v(_vm._s(_vm.$t('Loading')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"herd-card__body",style:({ minHeight: _vm.chartHeight + 'px' })},[_c('sci-chart-herd-weight',{key:_vm.chartKey,staticClass:"herd-card__chart",attrs:{"sid":_vm.system.id,"systemId":_vm.system.id,"height":_vm.chartHeight},on:{"loaded":_vm.onLoaded,"failed":_vm.onFailed}}),_vm._v(" "),(!_vm.isReady)?_c('div',{staticClass:"herd-card__overlay"},[(_vm.isLoading)?_c('chart-skeleton',{attrs:{"height":_vm.chartHeight}}):_c('div',{staticClass:"herd-card__message"},[_c('span',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(_vm.isFailed)?_c('button',{staticClass:"herd-card__retry",attrs:{"type":"button"},on:{"click":_vm.reload}},[_vm._v("\n                    "+_vm._s(_vm.$t('Retry'))+"\n                ")]):_vm._e()])],1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"herds-view"},[_c('div',{staticClass:"herds-grid"},[(_vm.loading)?_vm._l((_vm.skeletonsCount),function(n){return _c('div',{key:'skeleton-' + n,staticClass:"herd-card-skeleton"},[_c('div',{staticClass:"skeleton-line"}),_vm._v(" "),_c('chart-skeleton',{attrs:{"height":_vm.chartHeight}})],1)}):_vm._l((_vm.systems),function(system){return _c('system-herd-weight-card',{key:system.id,attrs:{"system":system,"chartHeight":_vm.chartHeight}})})],2),_vm._v(" "),(!_vm.loading && _vm.error)?_c('div',{staticClass:"herds-view__state"},[_c('span',[_vm._v(_vm._s(_vm.$t('SystemsLoadFailed')))]),_vm._v(" "),_c('button',{staticClass:"herds-view__retry",attrs:{"type":"button"},on:{"click":_vm.getData}},[_vm._v(_vm._s(_vm.$t('Retry')))])]):(!_vm.loading && _vm.systems.length == 0)?_c('div',{staticClass:"herds-view__state"},[_c('span',[_vm._v(_vm._s(_vm.$t('NoSystemsWithWeight')))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/26.e0e85a5ba3442a458adf.js